import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import { memo, useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  className?: string
}

function NavBarLoginButton(props: Props) {
  const { className } = props

  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const onLoginClick = useCallback(() => showModal(<AccountAccessModal />), [showModal])

  const loginText = intl.formatMessage({
    id: 'PzcSUqTGzjiNHFXJC3x_',
    defaultMessage: 'Log in',
    description: 'Login button text in navigation bar on the login or signup page',
  })

  return (
    <TextButton
      className={className}
      kind="secondary"
      variant="default"
      onClick={onLoginClick}
    >
      {loginText}
    </TextButton>
  )
}

export default memo(NavBarLoginButton)
